export const cookieBannerTranslations = {
  en: {
    title: 'We value your privacy',
    description: 'We use essential cookies for functionality and optional analytics cookies to improve Finley.',
    learnMore: 'Learn more',
    acceptAll: 'Accept all',
    essentialOnly: 'Essential only',
  },
  de: {
    title: 'Wir respektieren deine Privatsphäre',
    description: 'Wir nutzen notwendige Cookies für die Funktionalität und optionale Analyse-Cookies, um Finley zu verbessern.',
    learnMore: 'Mehr erfahren',
    acceptAll: 'Alle akzeptieren',
    essentialOnly: 'Nur notwendige',
  },
} as const

export type CookieBannerLocale = keyof typeof cookieBannerTranslations
